import React, { useEffect, useRef, useState } from 'react';
import { TreatmentType } from '../models/superbit-api-models';
import { Select, TimePicker, Tooltip, TreeSelect } from 'antd';
import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
import './_TaskAddTask.css';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faPlus, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
// import moment from 'moment';
import { SimulatorModel } from '../models/SimulatorModel';
import { WhatsAppModel } from '../models/WhatsAppModel';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { set, template } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import { LeadsModel } from '../models/LeadsModel';
import { useNavigate } from 'react-router-dom';
import { setReloadLeadTreatments } from '../app-context/leadsSlice';
import _ from 'lodash';
import { da } from 'date-fns/locale';
import { DraftEditor } from './_DraftEditor';
// import 'antd/dist/antd.css';
import moment from 'moment-timezone';
import draftToHtml from 'draftjs-to-html';
import { setReloadClientTreatments, setReloadSuesTreatments, setTaskStatusNotification } from '../app-context/tasksSlice';
import DOMPurify from "dompurify";


type Props = {
    ShowHidePopup: Function;
    ClosePopup?: Function;
    OnApprove?: Function;
    dataToEdit: any;
    onSave?: Function;
    type: number;
    messageTitle?: string;
    statuses: any[];
    customersList?: any[];
    usersList?: any[];
    customerId?: string;
};

const dic = {
    "policies": "פוליסות",
    "sues": "תביעות",
    "offers": "הצעות",
    "leads": "לידים",
    "riders": "מנויים"
} as const;

const TasksAddTaskPopup = (props: Props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const editorRef = useRef<TinyMCEEditor | null>(null);
    const CreatedDateRef = React.createRef<DatePicker>();

    const simulatorModel: SimulatorModel = new SimulatorModel();
    const whatsAppModel: WhatsAppModel = new WhatsAppModel();
    const customerModel = new CustomerCardModel();

    const [loading, setLoading] = useState<boolean>(false);

    const [mainTitle, setMainTitle] = useState<string>('הוספת משימה');
    const [currentUser, setCurrentUser] = useState<any | null>();

    const [timeFormat, setTimeFormat] = useState<string>('HH:mm');
    // const [eventDate, setEventDate] = useState<Date | null>(null);
    const [popUpType, setPopUpType] = useState<TreatmentType>(TreatmentType._0);
    const [showPrintBtn, setShowPrintBtn] = useState<boolean>(false);

    const [aditionalActionList, setAdditionalActionList] = useState<any[]>([]);
    const [showNewAction, setShowNewAction] = useState<boolean>(false);
    const [newAction, setNewAction] = useState<any>({
        date: null,
        owner: '',
        label: '',
        description: ''
    });
    const [statusesList, setStatusesList] = useState<any[]>(props.statuses);
    const [agentsList, setAgentsList] = useState<any[]>([]);
    const [selectedAgent, setSelectedAgent] = useState<any | null>(null)
    const [inssuranceCompanyListList, setInssuranceCompanyListList] = useState<any[]>([])
    const [selectedCompany, setSelectedCompany] = useState<any | null>(null)
    const [usersList, setUsersList] = useState<any[]>(props.usersList ? [...props.usersList] : []);
    const [selectedUser, setSelectedUser] = useState<any | null>(null)
    const [selectedHandler, setSelectedHandler] = useState<string>('')
    const [customersList, setCustomersList] = useState<any[]>(props.customersList ? [...props.customersList] : []);
    const [selectedCustomer, setSelectedCustomer] = useState<any | null>(null)

    const [endTime, setEndTime] = useState<string>('00:00');
    const [alertTime, setAlertTime] = useState<string>('00:00');
    // 
    const [currentData, setCurrentData] = useState<any>(props.dataToEdit);
    const [initialData, setInitialData] = useState<any>(_.cloneDeep(props.dataToEdit));
    const [validationErrors, setValidationErrors] = useState<any>({
        endDate: false,
        topic: false,
        selectedUser: false,
        selectedHandler: false
    });
    const [changesList, setChangesList] = useState<string[]>([]);
    const [editMode, setEditMode] = useState<boolean>(false);

    const [templates, setTemplates] = useState<any[]>([]);
    const [nameTemplate, setNameTemplate] = useState<string>('');

    const [treatmentsRelations, setTreatmentsRelations] = useState<any[]>([]);
    const [treeTreatmentData, setTreeTreatmentData] = useState<any[]>([]);
    const [chooseRelation, setChooseRelation] = useState<string>('');

    const [disabledEditMode, setDisabledEditMode] = useState<boolean>(false);
    const [templateBodyEmail, setTemplateBodyEmail] = useState<string>('');

    const leadIdForTreatment = useSelector((state: RootState) => state.leads.leadIdForTreatment);

    // get info from where i create the treatment
    const createTreatmentFrom = useSelector((state: RootState) => state.tasks.createTreatmentFrom);
    // create task from lead page 
    const phoneNumberOfLead = useSelector((state: RootState) => state.leads.phoneNumberOfLead);
    const sueInsuranceCompanyId = useSelector((state: RootState) => state.sues.sueInsuranceCompanyId);

    const [bodyEmailData, setBodyEmailData] = useState<string>(' ');
    const [insuranceCompanyReadOnly, setInsuranceCompanyReadOnly] = useState<boolean>(false);

    const [isDragging, setIsDragging] = useState<boolean>(false);
    const [position, setPosition] = useState<any>({ x: (1920 * 0.4), y: 120 })
    const [offset, setOffset] = useState<any>({ x: 0, y: 0 })

    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup();
        }
    }

    const approve = () => {
        if (props.OnApprove) {
            props.OnApprove();
        }
    }
    const compareDataBeforeSaving = (oldData: any, newData: any) => {

    }
    const onSaveAssignment = async () => {
        const dataToSave = getCurrentData();
        console.log('currentData', currentData)
        console.log('dataToSave', dataToSave)
        let hasErrors = false;
        if (!dataToSave.endDate || dataToSave.endDate == '' || String(dataToSave.endDate).startsWith('0001-01-01')) {
            const errors = validationErrors;
            errors.endDate = true;
            setValidationErrors(errors);
            hasErrors = true;
        }
        // if(!dataToSave.alertDate) {
        //     const errors = validationErrors;
        //     errors.alertDate = true;
        //     setValidationErrors(errors);
        //     hasErrors = true;
        // }
        if (!dataToSave.topic || dataToSave.topic == '') {
            const errors = validationErrors;
            errors.topic = true;
            setValidationErrors(errors);
            hasErrors = true;
        }
        if (!dataToSave.belongsToId || dataToSave.belongsToId == "") {
            console.log('error belongsToId selectedHandler')
            const errors = validationErrors;
            errors.selectedHandler = true;
            setValidationErrors(errors);
            hasErrors = true;
        }
        if (hasErrors) {
            setCurrentData(dataToSave);
            return;
        }
        const dataKeys = Object.keys(initialData);
        let editHistory = '';
        if (dataToSave.id) {
            dataKeys.forEach((key: string) => {
                if (initialData[key] !== dataToSave[key] && key !== 'treatmentActivities' && key !== 'treatmentDocuments') {
                    console.log('onSave data changed', key, 'changed')
                    switch (key) {
                        case 'customerId':
                            if (initialData.customerId === dataToSave.customerId) {
                                break;
                            }
                            const previousUser = customersList.find((a: any) => a.value == initialData.customerId);
                            const currentUser = customersList.find((a: any) => a.value == dataToSave.customerId);
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<b>תיק שונה </b>`;
                            if (previousUser) {
                                editHistory += ` מ-${previousUser.label}`;
                            }
                            if (currentUser) {
                                editHistory += ` ל-${currentUser.label}`;
                            }
                            break;
                        case 'topic': {
                            if (initialData.topic === dataToSave.topic) {
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<p style={{color: 'gray', fontWeight: 'bold'}} >נושא שונה</p>`;
                            editHistory += `<b> מ-</b>${initialData.topic}`;
                            editHistory += `<b> ל-</b>${dataToSave.topic}`;
                            break;
                        }
                        case 'assignmentStatusId': {
                            if (initialData.assignmentStatusId === dataToSave.assignmentStatusId) {
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<p style={{color: 'gray', fontWeight: 'bold'}} >סטטוס שונה</p>`;
                            const prevStatus = statusesList.find((s: any) => s.value == initialData.assignmentStatusId)
                            const newStatus = statusesList.find((s: any) => s.value == dataToSave.assignmentStatusId)
                            if (prevStatus) {
                                editHistory += `<b> מ-</b>${prevStatus.label}`;
                            }
                            if (newStatus) {
                                editHistory += `<b> ל-</b>${newStatus.label}`;
                            }
                            break;
                        }
                        case 'companyId': {
                            if (initialData.companyId === dataToSave.companyId) {
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<p style={{color: 'gray', fontWeight: 'bold'}} >חברה שונה</p>`;
                            const prevCompany = inssuranceCompanyListList.find((s: any) => s.value == initialData.companyId)
                            const newCompany = inssuranceCompanyListList.find((s: any) => s.value == dataToSave.companyId);
                            if (prevCompany) {
                                editHistory += `<b> מ-</b>${prevCompany.label}`;
                            }
                            if (newCompany) {
                                editHistory += `<b> ל-</b>${newCompany.label}`;
                            }
                            if (dataToSave.companyId === null) {
                                editHistory += `<b>ל- </b> ריק`;
                            }
                            break;
                        }
                        case 'agentId': {
                            if (initialData.agentId === dataToSave.agentId) {
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<p style={{color: 'gray', fontWeight: 'bold'}} >סוכן שונה</p>`;
                            const prevCompanyName = agentsList.find((s: any) => s.value == initialData.agentId)
                            const newCompanyName = agentsList.find((s: any) => s.value == dataToSave.agentId);
                            if (prevCompanyName) {
                                editHistory += `<b> מ-</b>${prevCompanyName.label}`;
                            }
                            if (newCompanyName) {
                                editHistory += `<b> ל-</b>${newCompanyName.label}`;
                            }
                            break;
                        }
                        case 'belongsToId': {
                            if (initialData.belongsToId === dataToSave.belongsToId) {
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<p style={{color: 'gray', fontWeight: 'bold'}} > שונה</p>`;
                            const prevCompanyName = usersList.find((s: any) => s.value == initialData.belongsToId)
                            const newCompanyName = usersList.find((s: any) => s.value == dataToSave.belongsToId)
                            if (prevCompanyName) {
                                editHistory += `<b> מ-</b>${prevCompanyName.label}`;
                            }
                            if (newCompanyName) {
                                editHistory += `<b> ל-</b>${newCompanyName.label}`;
                            }
                            break;
                        }
                        case 'endDate': {
                            if (initialData.endDate === dataToSave.endDate) {
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<p style={{color: 'gray', fontWeight: 'bold'}} >יעד סיום שונה</p>`;
                            editHistory += `<b> מ-</b>${initialData.endDate}`;
                            editHistory += ` ל-${dataToSave.endDate}`;
                            break;
                        }
                        case 'alertDate': {
                            if (initialData.alertDate === dataToSave.alertDate) {
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<p style={{color: 'gray', fontWeight: 'bold'}} >יעד סיום שונה</p>`;
                            editHistory += `<b> מ-</b>${initialData.alertDate}`;
                            editHistory += `<b> ל-</b>${dataToSave.alertDate}`;
                            break;
                        }
                        case 'emailBody': {
                            if (initialData.emailBody === dataToSave.emailBody) {
                                break;
                            }
                            if (editHistory !== '') {
                                editHistory += ",\n ";
                            }
                            editHistory += `<p style={{color: 'gray', fontWeight: 'bold'}} >הערות שונו</p>`;
                            editHistory += `<b> ל-<b>${dataToSave.emailBody}`;
                            break;
                        }
                        // emailBody
                        default:
                            // if(initialData[key] != dataToSave[key]) {
                            //     console.log('onSave data changed', key, 'changed')
                            // }
                            break;
                    }
                }
            })
            if (changesList.length > 0) {
                // console.log('onSave data changed', changesList);
                changesList.forEach((ch: string) => {
                    if (editHistory !== '') {
                        editHistory += "\n";
                    }
                    editHistory += `${ch}`;
                })
            }
            console.log('onSave data changed', editHistory);
        } else {
            editHistory += `<p style={{color: 'gray', fontWeight: 'bold'}} >המשימה הוקמה </p>`;
            if (selectedHandler) {
                editHistory += '<b>לביצוע ע"י </b>' + selectedHandler + "\n ";
            }
            if (dataToSave.emailBody !== '') {
                editHistory += `<b>הערות</b>`;
                editHistory += ` "${dataToSave.emailBody}"`;
            } else {

            }
        }
        if (!dataToSave.id) {
            dataToSave.treatmentActivities.push({
                createdDate: moment().format('YYYY-MM-DDTHH:mm'),
                topic: 'המשימה הוקמה ',
                note: editHistory.replace(/&nbsp;/g, ' '),
                createdById: currentUser.id
            })
        } else {
            if (!dataToSave.treatmentActivities) {
                dataToSave.treatmentActivities = [];
            }
            dataToSave.treatmentActivities.push({
                createdDate: moment().format('YYYY-MM-DDTHH:mm'),
                topic: 'עידכון משימה',
                note: editHistory.replace(/&nbsp;/g, ' '),
                createdById: currentUser.id
            })
        }
        if (props.onSave) {
            if (!dataToSave.id) {
                dataToSave.id = '00000000-0000-0000-0000-000000000000';
            }
            if (!dataToSave.createdDate) {
                dataToSave.createdDate = new Date();
            }
            if (!dataToSave.eventDate) {
                dataToSave.eventDate = new Date();
            }
            if (!dataToSave.startDate) {
                dataToSave.startDate = new Date();
            }
            let res = await props.onSave(dataToSave);
            if (res) {

                dispatch(setTaskStatusNotification(true));
                // create from customer - need to reload the treatments of the customer
                if (props.customerId && props.customerId.length > 0) {
                    console.log('create from customer - need to reload the treatments of the customer', props.customerId)
                    if (createTreatmentFrom && createTreatmentFrom.type == 'policy' || createTreatmentFrom.type == 'rider' && createTreatmentFrom.id) {
                        dispatch(setReloadClientTreatments({ show: true, id: createTreatmentFrom.id }));
                    }
                }
                // create from lead - need to reload the treatments of the lead
                if (leadIdForTreatment && leadIdForTreatment.length > 0) {
                    console.log('create from lead - need to reload the treatments of the lead', leadIdForTreatment)
                    dispatch(setReloadLeadTreatments(true));
                }
                if (createTreatmentFrom && createTreatmentFrom.type == 'sue') {
                    dispatch(setReloadSuesTreatments(true));
                }
            }
        }

    }

    // const onEventDateChange = (newDate: Date) =>{
    //     setEventDate(newDate);
    // }
    const onEndDateChange = (newDate: Date) => {
        const data = getCurrentData();
        let newDateString = moment(newDate).format('YYYY-MM-DD');
        if (moment(newDateString).isValid()) {
            if (endTime == '00:00') {
                // set endTime of now by default when user select date
                setEndTime(moment(new Date()).format('HH:mm'));
                newDateString += " " + moment(new Date()).format('HH:mm');
                data.endDate = moment(newDateString).format('YYYY-MM-DDTHH:mm');
            } else if (endTime && endTime.length > 0 && endTime != '00:00') {
                newDateString += " " + endTime;

                data.endDate = moment(newDateString).format('YYYY-MM-DDTHH:mm');
            }

            // set endTime of now by default when user select date
            setEndTime(moment(new Date()).format('HH:mm'));
            // add time to date 




            const error = validationErrors;
            error.endDate = false;
            setValidationErrors(error);
        } else {
            data.endDate = null;
        }
        console.log('DateChange', data.endDate)
        setCurrentData(data);
    }

    const onAlertDateChange = (newDate: Date) => {
        const data = getCurrentData();
        let newDateString = moment(newDate).format('YYYY-MM-DD');
        if (moment(newDateString).isValid()) {
            // set alert time of now by default when user select date
            if (alertTime == '00:00') {
                setAlertTime(moment(new Date()).format('HH:mm'));
                newDateString += " " + moment(new Date()).format('HH:mm');
                data.alertDate = moment(newDateString).format('YYYY-MM-DDTHH:mm');
            } else if (alertTime && alertTime.length > 0 && alertTime != '00:00') {
                newDateString += " " + alertTime;
                data.alertDate = moment(newDateString).format('YYYY-MM-DDTHH:mm');
            }
        } else {
            data.alertDate = null;
        }
        console.log('DateChange', data.alertDate)
        setCurrentData(data);
    }

    const onEndTimeChange: any = (time: any, timeString: string) => {
        console.log(time, timeString);
        setEndTime(timeString);
        const data = getCurrentData();
        if (data.endDate) {
            let newDateString = moment(data.endDate).format('YYYY-MM-DD');
            newDateString += " " + timeString;
            data.endDate = moment(newDateString).format('YYYY-MM-DDTHH:mm');
            console.log('DateChange', data.endDate)
            setCurrentData(data);
        }

    };

    const onBlurCreateTime = (e: any) => {
        let newTime = e.target.value;
        // add : after 2 chars
        console.log('onBlurCreateTime-newTime', newTime)
        if (!newTime || newTime == '') {
            return;
        }

        newTime = newTime.replace(/(\d{2})(\d)/, '$1:$2');
        setEndTime(newTime);
        const data = getCurrentData();
        if (newTime) {
            let newDateString = moment(data.endDate).format('YYYY-MM-DD');
            newDateString += "T" + newTime;
            data.endDate = new Date(moment(newDateString).format('YYYY-MM-DDTHH:mm'));
            setCurrentData(data);
        }
    }

    const onAlertTimeChange: any = (time: any, timeString: string) => {
        console.log(time, timeString);
        setAlertTime(timeString);
        const data = getCurrentData();
        if (data.alertDate) {
            let newDateString = moment(data.alertDate).format('YYYY-MM-DD');
            newDateString += " " + timeString;
            const tz = "Asia/Jerusalem";
            data.alertDate = moment(newDateString).tz(tz).format('YYYY-MM-DDTHH:mm');
            console.log('DateChange', data.alertDate)
            setCurrentData(data);
        }
    };

    const onBlurAlertTime = (e: any) => {
        let newTime = e.target.value;
        // add : after 2 chars
        if (!newTime || newTime == '') {
            return;
        }
        newTime = newTime.replace(/(\d{2})(\d)/, '$1:$2');
        setAlertTime(newTime);
        const data = getCurrentData();
        if (newTime) {
            let newDateString = moment(data.alertDate).format('YYYY-MM-DD');
            newDateString += "T" + newTime;
            const tz = "Asia/Jerusalem";
            data.alertDate = moment(newDateString).tz(tz).format('YYYY-MM-DDTHH:mm');
            setCurrentData(data);
        }
    }

    const onEmailBodyChange = (html: string) => {
        // if (editorRef.current) {
        //     const htmlBody = editorRef.current.getContent();
        //     const data = getCurrentData();
        //     data.emailBody = htmlBody;
        //     setCurrentData(data);
        // }
        if (html && html.length > 0) {
            const data = getCurrentData();
            data.emailBody = html;
            setCurrentData(data);
            setBodyEmailData(html);
        }
    }

    const onClearNewAction = () => {
        setNewAction({
            date: null,
            owner: '',
            label: '',
            description: ''
        });
        setShowNewAction(false)
    }

    const onSaveNewAction = async () => {
        const currentActionsList = aditionalActionList;
        const action = newAction;
        const data = getCurrentData();
        data.treatmentActivities.push({
            createdDate: action.date,
            topic: action.label,
            note: action.description,
            createdById: currentUser.id
        });
        setCurrentData(data);
        console.log('onSaveNewAction', currentActionsList);
        // currentActionsList.push(action);
        // setNewAction({
        //     date: null,
        //     owner: '',
        //     label: '',
        //     description: ''
        // });
        // await setAdditionalActionList(currentActionsList);
        setShowNewAction(false)
        console.log('onSaveNewAction', currentActionsList);
    }

    const onDeleteAction = async (i: number) => {
        const currentActionsList = aditionalActionList;
        await setAdditionalActionList([]);
        currentActionsList.splice(i, 1);
        await setAdditionalActionList(currentActionsList);
        setShowNewAction(false)
        console.log('onDeleteAction', currentActionsList);
    }

    const onDeleteActivity = async (index: number) => {
        const data = getCurrentData();
        data.treatmentActivities.splice(index, 1);
        setCurrentData(data);
    }

    const onNewActionParameterChange = (name: string, value: string | Date) => {
        const action = newAction;
        action[name] = moment(value).format('YYYY-MM-DD HH:mm');
        setNewAction(action);
        console.log('onNewActionParameterChange', name, value, newAction)
    }

    const onNewActionParameterChange2 = async (name: string, event: any) => {
        const newValue = event.target.value;
        const action = newAction;
        action[name] = newValue;
        await setNewAction(action);
        console.log('onNewActionParameterChange', name, newValue, newAction)
    }

    const setReferrence = () => {
        const data = getCurrentData();
        if (data) {
            if (data.policyRelatedId) {
                setChooseRelation(data.policyRelatedId);
            }
            if (data.sueRelatedId) {
                setChooseRelation(data.sueRelatedId);
            }
            if (data.offerRelatedId) {
                setChooseRelation(data.offerRelatedId);
            }
            // if (data.leadRelatedId) {
            //     setChooseRelation(data.leadRelatedId);
            // }
        }
    }

    const getComboData = async () => {


        var customersListTemp: any[] = [];
        // const allCustomersStorage = localStorage.getItem('allCustomers');
        const allCustomersStorage = sessionStorage.getItem('allCustomers');
        if (!allCustomersStorage) {
            try {
                //get all clients list for the create new assigment
                const customers = await simulatorModel.customerGetAll();
                let allCustomers: any[] = [];
                allCustomers = customers.map((u: any, i: number) => {
                    return {
                        value: u.id,
              label: u.fullName,
              identifier:u.identifier
                    }
                })
                console.log('allCustomers', allCustomers)
                // localStorage.setItem('allCustomers', JSON.stringify(allCustomers));
                sessionStorage.setItem('allCustomers', JSON.stringify(allCustomers));
                customersListTemp = [...allCustomers];
                setCustomersList(allCustomers);
            }
            catch (error) {
                console.log('error', error)

            }
        } else {
            const customers = JSON.parse(allCustomersStorage);
            console.log('allCustomers', customers)
            customersListTemp = [...customers];
            setCustomersList(customers)
        }


        const insuranceCompaniesData = await simulatorModel.getInsuranceCompanies();
        const icTempDataKeys = Object.keys(insuranceCompaniesData);
        const fixedInsuranceCompanies: any[] = [];
        icTempDataKeys.forEach((k: string) => {
            fixedInsuranceCompanies.push({
                value: insuranceCompaniesData[k].description,
                label: insuranceCompaniesData[k].name
            })
        })
        setInssuranceCompanyListList(fixedInsuranceCompanies);
        const agentsData = await simulatorModel.getCustomerCardAgents();
        setAgentsList(agentsData.map((a: any) => {
            return {
                value: a.id,
                label: a.name
            }
        }))
        // get referrer data from customer card model for referrences setCustomerRef by using customerId from currentData or props.customerId
        if (currentData.customerId || props.customerId) {
            let customerIdFinal = currentData.customerId ? currentData.customerId : props.customerId;
            // get customer name and id for setting selectedCustomer for customer name in first input in assignment 
            let customerSelected = customersListTemp.find((a: any) => a.value == customerIdFinal);
            if (customerSelected) {
                const data = getCurrentData();
                data.customerId = customerSelected.value;
                await setCurrentData(data);
                setSelectedCustomer(customerSelected)
            }
            else {
                customerSelected = { "label": "", "value": customerIdFinal };
                setSelectedCustomer(customerSelected)
            }
            // need to check 
            if (customerIdFinal) {
                await setCustomerRef(customerIdFinal);
                setReferrence();
            }
            if (props.customerId && props.customerId.length > 0) {
                setEditMode(true);
            }

        } else {
            console.log('init-customersList-no-customerId')
        }

        if (leadIdForTreatment && leadIdForTreatment.length > 0) {
            console.log('leadIdForTreatment', leadIdForTreatment)
            const lead = await new LeadsModel().getLeadForUpsert(leadIdForTreatment);
            setSelectedCustomer({
                label: lead.firstName + " " + lead.lastName,
                value: leadIdForTreatment
            })

            // need to check with Sara about get all client details from server (like name and identifier)
            ///////////////////////////////////////////////////
            const data = getCurrentData();
            if (lead) {
                data.customer = {
                    fullName: lead.firstName + " " + lead.lastName,
                    identifier: lead.identifier,
                };
            }
            setCurrentData(data);

            //////////////////////////////////////////////////
            // setSelectedUser get relatiuons from lead by using leadIdForTreatment
            await setCustomerRef(leadIdForTreatment);
            setReferrence();


            setEditMode(true);
        }

        setLoading(false);
    }

    const onStatusChange = (value: string) => {
        console.log('onStatusChange', value)
        const data = getCurrentData();
        if (value != '-1') {
            data.assignmentStatusId = value;
        } else {
            data.assignmentStatusId = null;
        }
        setCurrentData(data);
    }

    const onSelectAgent = (e: any) => {
        const agentName = e.target.value;
        const selected = agentsList.find((a: any) => a.label == agentName);
        if (selected) {
            setSelectedAgent(selected)
            const data = getCurrentData();
            data.agentId = selected.value;
            setCurrentData(data);
        } else {
            setSelectedAgent({
                label: agentName,
                value: null
            })
        }
    }
    const onSelectAgent2 = (value: string) => {
        const selected = agentsList.find((a: any) => a.value == value);
        // const agentName = selected.label;
        if (selected) {
            setSelectedAgent(selected)
            const data = getCurrentData();
            data.agentId = selected.value;
            setCurrentData(data);
        } else {
            setSelectedAgent({
                label: '',
                value: null
            })
        }
    }
    const onSelectBelongsTo = (e: any) => {
        const userName = e.target.value;
        const selected = usersList.find((a: any) => a.label == userName);
        let selectHandler = selectedHandler;
        selectHandler = userName;
        setSelectedHandler(selectHandler)
        if (selected) {
            const data = getCurrentData();
            data.belongsToId = selected.value;
            setCurrentData(data);
            const errors = validationErrors;
            errors.selectedHandler = false;
            setValidationErrors(errors);
        } else {
            // setSelectedHandler(null)
            const data = currentData;
            data.belongsToId = null;
            setCurrentData(data);
        }
    }


    const onSelectInsuranceCompany = async (e: any) => {
        const companyName = e.target.value;
        const selected = inssuranceCompanyListList.find((a: any) => a.label == companyName);

        if (selected) {
            setSelectedCompany(selected)
            const data = getCurrentData();
            data.companyId = selected.value;
            await setCurrentData(data);
        } else {
            setSelectedCompany({
                label: companyName,
                value: null
            });
            if (companyName == '') {
                const data = getCurrentData();
                data.companyId = null;
                await setCurrentData(data);
            }
        }
    }


    const setRelationsData = (relationDataArg: any) => {
        const relationsData = relationDataArg;
        if (relationsData) {
            if (relationsData.leads && relationsData.leads.length > 0) {
                relationsData.leads.map((lead: any) => {
                    if (lead.offers && lead.offers.length > 0) {
                        let offers = [...lead.offers];
                        relationsData['offers'] = offers;
                    }
                })
            }
            const relationsDataKeys = Object.keys(relationsData);
            const relationsDataList: any[] = [];
            relationsDataKeys.forEach((k: string, idx: number) => {
                if (k !== 'policyRelated' && k !== 'leadRelated' && k !== 'sueRelated' && k !== 'open' && k !== 'elementaryInsurancePolicies' &&
                    (k !== 'leads')) {
                    const relation = relationsData[k];
                    const relationData: any = {
                        title: dic[k as keyof typeof dic] ? dic[k as keyof typeof dic] : k,
                        value: idx,
                        key: idx,
                        selectable: false,
                        type: k,
                    }
                    if (relation && relation.length > 0) {
                        const children = relation.map((c: any, i: number) => {
                            console.log('c', c)
                            return {
                                title: k == 'policies' ? c.policyNumber : k == 'sues' ? c.sueNumber ? c.sueNumber + "-" + c.internalNumber : "0-" + c.internalNumber : k == "leads" ? c.identifier : (k == "riders" && c.subscriberNumber) ? c.subscriberNumber : c.offerIdentity,
                                value: c.id,
                                key: c.id,
                                selectable: true,
                                type: k == 'policies' ? 'policies' : k == 'sues' ? 'sues' : k == 'leads' ? 'leads' : k == 'riders' ? 'riders' : 'offers'
                            }
                        })
                        relationData["children"] = children;
                    }
                    relationsDataList.push(relationData);
                }
            })
            setTreeTreatmentData(relationsDataList);
        }
    }


    const setCustomerRef = async (customerId: string) => {

        const storedRelations = sessionStorage.getItem(`treatmentsRelations-${customerId}`);
        if (storedRelations) {
            const relationsData = JSON.parse(storedRelations);
            console.log('setCustomerRef-storedRelations-relationDate-857', relationsData)
            setTreatmentsRelations(relationsData);
            setRelationsData(relationsData);
            return;
        }
        const relationsData = await customerModel.treatmentsLoadRelations(customerId);
        console.log('treatmentsLoadRelations- relationDate-858')
        setTreatmentsRelations(relationsData);
        if (relationsData) {
            sessionStorage.setItem(`treatmentsRelations-${customerId}`, JSON.stringify(relationsData));
            setRelationsData(relationsData);
        }
    }

    const onSelectCustomer = async (e: any) => {
        const customerName = e.target.value;

        console.log('onSelectCustomer-customerName', customerName)
        const selected = customersList.find((a: any) => a.label == customerName);
        console.log('onSelectCustomer-selected', selected)
        if (selected) {
            console.log('onSelectCustomer-selected-inside', selected)
            setSelectedCustomer(selected)
            // customerId
            const data = getCurrentData();
            data.customerId = selected.value;
            await setCurrentData(data);
            setCustomerRef(selected.value);
        } else {
            setSelectedCustomer({
                label: customerName,
                value: null
            })
        }
    }


    const onTopiChange = async (e: any) => {
        const newValue = e.target.value;
        const data = getCurrentData();
        data.topic = newValue;
        await setCurrentData(data);
    }
    const onFileUpload = (event: any) => {
        const fileUploaded = event.target.files[0];
        const fileSize: string = ((fileUploaded.size / 1024) / 1024).toFixed(4);
        if (parseFloat(fileSize) > 5) {
            return;
        }
        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            reader.onloadend = () => {
                const data = getCurrentData();
                const fileName = (new Date().getTime()) + "_" + fileUploaded.name;
                if (!data.fileAttachments) {
                    data.fileAttachments = [];
                }
                data.fileAttachments.push(
                    {
                        FileName: fileName,
                        Content: reader.result
                    }
                );
                const fileChages: any[] = changesList;
                fileChages.push('הוסף קובץ ' + fileName);
                setChangesList(fileChages);
                setCurrentData(data);
            }
            reader.readAsDataURL(fileUploaded);
        }
    };

    const getCurrentData = () => {
        return JSON.parse(JSON.stringify(currentData));

    }

    const onDeleteAttachment = (index: number) => {
        const data = getCurrentData();
        data.fileAttachments.splice(index, 1);
        setCurrentData(data);
    }
    const onDeleteDocument = (index: number) => {
        const data = getCurrentData();
        if (data.treatmentDocuments && data.treatmentDocuments.length > 0 && data.treatmentDocuments[index]) {

            customerModel.customerDocumentsDelete(data.treatmentDocuments[index].id).then((res: any) => {
                // const data = getCurrentData();
                // const file = data.treatmentDocuments[index];
                // const fileUrlData = file.url.split("/");
                // const fileName = fileUrlData[fileUrlData.length - 1];
                // data.treatmentDocuments[index].isDeleted = true;
                // // data.treatmentDocuments.splice(index, 1);
                // const fileChages: any[] = changesList;
                // fileChages.push('קובץ הוסר' + fileName);
                // setChangesList(fileChages);
                // setCurrentData(data);
                setChangesList(prevList => [...prevList, 'נמחק מסמך ' + (
                    data.treatmentDocuments && data.treatmentDocuments[index] ? data.treatmentDocuments[index].fileName : '')]);
                setCurrentData((prev: any) => {
                    const newData = { ...prev };
                    if (newData.treatmentDocuments) {
                        newData.treatmentDocuments.splice(index, 1);
                    }
                    console.log('onDeleteDocument-newData', newData)
                    // Update changes list too
                    // setChangesList(prevList => [...prevList, 'נמחק מסמך ' + (
                    //     data.treatmentDocuments && data.treatmentDocuments[index] ? data.treatmentDocuments[index].fileName : '')]);
                    return newData;
                });

            })
        }
    }

    const emptyFunc = () => { }


    const templateChange = (value: string) => {

        console.log('value', value);
        setNameTemplate(value);
        setBodyEmailData(`${value}`);
        const data = _.cloneDeep(currentData);
        // const html = draftToHtml(value ? value : '');

        data.emailBody = value;
        setCurrentData(data);
    }

    // const onClear = () => {
    //     const data = getCurrentData();
    //     if (data.policyRelatedId) {
    //         data.policyRelatedId = undefined;
    //     }
    //     if (data.leadRelatedId) {
    //         data.leadRelatedId = undefined;
    //     }
    //     if (data.sueRelatedId) {
    //         data.sueRelatedId = undefined;
    //     }
    //     if (data.offerRelatedId) {
    //         data.offerRelatedId = undefined;
    //     }
    //     setChooseRelation('');
    //     setCurrentData(data);
    // }

    const onChangeRelations = (value: any) => {
        console.log('onChangeRelations', value)
        const data = getCurrentData();
        let selectedItem = null;

        if (value == undefined) {
            data["policyRelatedId"] = undefined;
            // need to check about next line in future
            //data["leadRelatedId"] = undefined;
            data["offerRelatedId"] = undefined;
            data["sueRelatedId"] = undefined;
            data["elementaryPolicyId"] = undefined;
            setCurrentData(data);
            setChooseRelation('');
            return;
        }

        // need to check whiche branch in tree data treeTreatmentData  is selected if is policies or leads or sues
        for (let i = 0; i < treeTreatmentData.length; i++) {
            let Item = treeTreatmentData[i].children && treeTreatmentData[i].children.length > 0 && treeTreatmentData[i].children.find((a: any) => a.key == value);
            if (Item) {
                console.log('Item', Item)
                selectedItem = Item;
            }
        }

        let newSubjectText = '';
        console.log('selectedItem.type', selectedItem.type)

        if (selectedItem) {
            switch (selectedItem.type) {
                case 'policies':
                    data["policyRelatedId"] = value;
                    newSubjectText = `$פוליסה מספר: ${selectedItem.title}`;
                    data["leadRelatedId"] = null;
                    data["offerRelatedId"] = null;
                    data["sueRelatedId"] = null;
                    break;
                case 'leads':
                    data["leadRelatedId"] = value;
                    newSubjectText = `ליד מספר: ${selectedItem.title}`;
                    data["policyRelatedId"] = null;
                    data["riderRelatedId"] = null;
                    data["sueRelatedId"] = null;
                    break;
                case 'offers':
                    data["offerRelatedId"] = value;
                    newSubjectText = `,  הצעה מספר: ${selectedItem.title}`;
                    data["policyRelatedId"] = null;
                    data["sueRelatedId"] = null;
                    data["riderRelatedId"] = null;
                    break;
                case 'sues':
                    data["sueRelatedId"] = value;
                    newSubjectText = `תביעה מספר: ${selectedItem.title}`;
                    data["policyRelatedId"] = null;
                    data["riderRelatedId"] = null;
                    data["offerRelatedId"] = null;
                    break;
                case 'riders':
                    data["riderRelatedId"] = value;
                    newSubjectText = `מנוי מספר: ${selectedItem.title}`;
                    data["policyRelatedId"] = null;
                    data["sueRelatedId"] = null;
                    data["offerRelatedId"] = null;
                    break;

                default:

            }
        }
        console.log('newSubjectText', newSubjectText)
        console.log('data', data)
        setChooseRelation(value);
        setCurrentData(data);
    }

    useEffect(() => {
        console.log('useEffect-TasksAddTaskPopup')

        setLoading(true);
        const fetchTempleteData = async () => {
            const templatesData = await customerModel.getAssignmentTemplates();
            templatesData.unshift({ name: 'בחר תבנית', text: '' });
            setTemplates(templatesData);
        }

        fetchTempleteData();
        const savedLoggedUser = localStorage.getItem('loggedUser');
        let loggedUser: any = {}
        if (savedLoggedUser) {
            loggedUser = JSON.parse(savedLoggedUser);
            setCurrentUser(loggedUser);
        }

        getComboData();

        setPopUpType(props.type);
        switch (props.type) {
            case TreatmentType._0:
                setShowPrintBtn(true)
                break;
            case TreatmentType._4:
                setShowPrintBtn(true)
                break;

            default:
                break;
        };

        if (currentData) {

            setBodyEmailData(currentData.emailBody ? currentData.emailBody : '');

            console.log('currentData-belongsToId', currentData)

            if (currentData.endDate) {
                const defaultEndTime = moment(currentData.endDate).format('HH:mm');
                setEndTime(defaultEndTime)
            }

            let data = getCurrentData();
            data.endDate = data.endDate ? moment(currentData.endDate, 'yyyy-MM-DDTHH:mm:ss').format('yyyy-MM-DD') : null;
            console.log('data.endDate', data.endDate)
            setCurrentData(data);

            if (!currentData.treatmentType) {
                currentData.treatmentType = 1;
            }
            if (!currentData.assignmentStatusId) {
                currentData.assignmentStatusId = '45cb3c16-f64f-40d5-9863-42a742ce4624';
            }
            if (currentData.id) {
                setMainTitle('עדכון משימה');
                // setEditMode(true);
            }
            if (currentData.companyId) {
                const selected = inssuranceCompanyListList.find((a: any) => a.value == currentData.companyId);
                setSelectedCompany(selected);

            }
            // setSelectedCustomer
            if (currentData.userId) {
                const selected = usersList.find((a: any) => a.value == currentData.userId);
                // const selected = usersList.find((a: any)=> a.label == userName);
                setSelectedUser(selected);
            } else {
                // setSelectedUser(loggedUser.id);
            }
            // setSelectedAgent

            if (currentData.alertDate) {
                const defaultAlertTime = moment(currentData.alertDate).format('HH:mm');
                setAlertTime(defaultAlertTime);
            }

            if (currentData.belongsToId && props.usersList) {
                console.log('usersList', props.usersList)
                const selected = props.usersList.find((a: any) => a.value == currentData.belongsToId);
                console.log('usersList-belongsToId', selected)
                if (selected) {
                    setSelectedHandler(selected.label);
                }
            }

            if (createTreatmentFrom && createTreatmentFrom.type && createTreatmentFrom.id) {
                if (createTreatmentFrom.type == 'policy') {
                    setChooseRelation(createTreatmentFrom.id);
                    currentData.policyRelatedId = createTreatmentFrom.id;
                    setCurrentData(currentData);
                    setDisabledEditMode(true);
                }
                else if (createTreatmentFrom.type == 'lead' && currentData.offerRelatedId && currentData.offerRelatedId.length > 0) {
                    setChooseRelation(currentData.offerRelatedId);
                    // currentData.offerRelatedId = createTreatmentFrom.id;
                    // setCurrentData(currentData);
                } else if (createTreatmentFrom.type == 'sue' && createTreatmentFrom.id && createTreatmentFrom.id.length > 0) {
                    //setChooseRelation(createTreatmentFrom.id);
                    setChooseRelation(currentData.sueRelatedId);
                    currentData.sueRelatedId = createTreatmentFrom.id;
                    setDisabledEditMode(true);
                    setCurrentData(currentData);
                } else if (createTreatmentFrom.type == 'rider' && createTreatmentFrom.id && createTreatmentFrom.id.length > 0) {
                    setChooseRelation(currentData.riderRelatedId);
                    currentData["riderRelatedId"] = createTreatmentFrom.id;
                    setCurrentData(currentData);
                    setDisabledEditMode(true);
                } else if (createTreatmentFrom.type == 'sign' && createTreatmentFrom.id && createTreatmentFrom.id.length > 0) {
                    setChooseRelation(createTreatmentFrom.id);
                    currentData.policyRelatedId = createTreatmentFrom.id;
                    setCurrentData(currentData);
                    setDisabledEditMode(true);
                }

                if (createTreatmentFrom.type == 'sue' || createTreatmentFrom.type == 'sign') {
                    if (sueInsuranceCompanyId && sueInsuranceCompanyId.length > 0) {
                        currentData.companyId = sueInsuranceCompanyId;
                        const selected = inssuranceCompanyListList.find((a: any) => a.value == sueInsuranceCompanyId);
                        setSelectedCompany(selected);
                        setInsuranceCompanyReadOnly(true);
                    }
                }
            }

        }
        setCurrentData(currentData);


    }, [])

    useEffect(() => {
        if (customersList && customersList.length > 0) {
            if (currentData && customersList.length > 0) {
                if (currentData.customerId) {
                    const selected = customersList.find((a: any) => a.value == currentData.customerId);
                    console.log('useEffect customer', selected)
                    setSelectedCustomer(selected);
                }
            }

        }
    }, [customersList])



    useEffect(() => {
        if (agentsList && agentsList.length > 0) {
            const loggedUser = localStorage.getItem('loggedUser');
            let loggedUserData: any = {}
            if (loggedUser) {
                loggedUserData = JSON.parse(loggedUser);
                const selected = agentsList.find((a: any) => a.value == loggedUserData.agentId);
                if (selected) {
                    setSelectedAgent(selected);
                }
            }
        }
    }, [agentsList])


    useEffect(() => {
        if (currentData) {
            if (currentData.companyId) {
                const selected = inssuranceCompanyListList.find((a: any) => a.value == currentData.companyId);
                setSelectedCompany(selected);
            }
        }
    }, [inssuranceCompanyListList]);


    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        console.log('handleMouseDown', e.clientX, e.clientY);
        setIsDragging(true);
        setOffset({
            x: e.clientX - position.x,
            y: e.clientY - position.y
        })
    }

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        console.log('handleMouseMove');
        if (isDragging) {
            setPosition({ x: e.clientX - offset.x, y: e.clientY - offset.y })
        }
    }

    const handleMouseUp = (): void => {
        console.log('handleMouseUp');
        setIsDragging(false);
    };


    return (<>
        <div className={`popup-wrapper add-treatment-popup add-task-popup ${props.type}`} style={{ zIndex: 1000 }}>{
            loading && (
                <PleaseWaitLayer />
            )
        }
            <section className="popup-window rtl" style={{ width: '900px', position: 'absolute', top: position.y, left: position.x }}>
                <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title" style={{ cursor: isDragging ? 'grabbing' : 'grab', }}
                            onMouseDown={handleMouseDown}
                            onMouseMove={handleMouseMove}
                            onMouseUp={handleMouseUp}
                            onMouseLeave={handleMouseUp}>
                            {mainTitle}
                        </div>
                    </div>
                    <div className="popup-body">
                        <div className="parameter-row single-item">
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="value">
                                        <input type='text'
                                            list="customer_list"
                                            placeholder='בחר תיק'
                                            disabled={!customersList || editMode}
                                            onChange={(e: any) => onSelectCustomer(e)}
                                            value={selectedCustomer ? selectedCustomer.label : ''}
                                        />
                                        <datalist id="customer_list">
                                            {customersList && customersList.map((a: any, i: number) => <option key={i} value={a.label}>{a.label}-{a.identifier}</option>)}
                                        </datalist>
                                    </div>
                                    <div className='error-message'>
                                        {/* *{this.state.errors.requiredField} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-row single-item">
                            <div className={`parameter-item${validationErrors.topic ? ' error' : ''}`}>
                                <div className="field">
                                    <div className="title">
                                        נושא
                                    </div>
                                    <div className="value">
                                        <input type='text' value={currentData ? currentData.topic : ''} onChange={(e: any) => onTopiChange(e)} />
                                    </div>
                                    <div className='error-message'>
                                        {/* *{this.state.errors.requiredField} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-row">
                            <div className={`parameter-item`} style={{ width: '23%' }}>
                                <div className="field">
                                    <div className="title">
                                        סטטוס:
                                    </div>
                                    <div className="value">
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="בחר סטטוס"
                                            defaultValue={"45cb3c16-f64f-40d5-9863-42a742ce4624"}
                                            value={currentData ? currentData.assignmentStatusId : ''}
                                            onChange={onStatusChange}
                                            options={
                                                props.statuses
                                            }
                                        />
                                    </div>
                                    <div className='error-message'>
                                    </div>
                                </div>
                            </div>

                            <div className={`parameter-item${validationErrors.selectedHandler ? ' error' : ''}`} style={{ width: '23%' }}>
                                <div className="field">
                                    <div className="title">
                                        לטיפול ע"י:
                                    </div>
                                    <div className="value">
                                        <input type='text'
                                            list="handler_list"
                                            placeholder='בחר מטפל'
                                            onChange={(e: any) => onSelectBelongsTo(e)}
                                            value={selectedHandler}
                                        />
                                        <datalist id="handler_list">
                                            {usersList && usersList.map((u: any, i: number) => <option key={i} value={u.label}>{u.label}</option>)}
                                        </datalist>

                                    </div>
                                    <div className='error-message'>
                                        שדה חובה
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item${validationErrors.endDate ? ' error' : ''}`} style={{ width: '27%' }}>
                                <div className="field">
                                    <div className="title">
                                        יעד סיום:
                                    </div>
                                    <div className={`value`}>
                                        <TimePicker
                                            variant="borderless"
                                            onChange={onEndTimeChange}
                                            onBlur={onBlurCreateTime}
                                            defaultValue={dayjs(endTime, timeFormat)}
                                            value={dayjs(endTime, timeFormat)}
                                            format={timeFormat}
                                            popupClassName='time-picker-time-list'
                                        />

                                        <CompDatePicker
                                            value={currentData && moment(currentData.endDate, 'yyyy-MM-DDTHH:mm:ss').format('yyyy-MM-DD') != '0001-01-01'
                                                ? new Date(currentData.endDate) : null}
                                            onChange={(e: any) => onEndDateChange(e)}
                                        />

                                    </div>
                                    <div className='error-message'>
                                        שדה חובה
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item`} style={{ width: '27%' }}>
                                <div className="field">
                                    <div className="title">
                                        תזכורת:
                                    </div>
                                    <div className="value">
                                        <TimePicker
                                            variant="borderless"
                                            onChange={onAlertTimeChange}
                                            onBlur={onBlurAlertTime}
                                            defaultValue={dayjs(alertTime, timeFormat)}
                                            value={dayjs(alertTime, timeFormat)}
                                            format={timeFormat}
                                            popupClassName='time-picker-time-list'
                                        />

                                        <CompDatePicker
                                            value={currentData.alertDate ? new Date(currentData.alertDate) : null}
                                            onChange={(e: any) => onAlertDateChange(e)}
                                        />

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="parameter-row">
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        חברה:
                                    </div>
                                    <div className="value">
                                        <input type='text'
                                            list="company_list"
                                            placeholder='חברה'
                                            onChange={(e: any) => onSelectInsuranceCompany(e)}
                                            value={selectedCompany ? selectedCompany.label : ''}
                                            disabled={insuranceCompanyReadOnly}
                                        />
                                        <datalist id="company_list">
                                            {inssuranceCompanyListList && inssuranceCompanyListList.map((a: any, i: number) => <option key={i} value={a.label}>{a.label}</option>)}
                                        </datalist>

                                    </div>
                                    <div className='error-message'>
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        סוכן:
                                    </div>

                                    <Select
                                        style={{ width: '100%', height: '37px' }}
                                        placeholder="בחר סוכן"
                                        value={selectedAgent ? selectedAgent.value : ''}
                                        onChange={onSelectAgent2}
                                        options={
                                            [
                                                {
                                                    label: 'בחר סוכן',
                                                    value: ''
                                                },
                                                ...agentsList
                                            ]
                                        }
                                    />
                                    <div className='error-message'>
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        שם תבנית:
                                    </div>

                                    <Select
                                        style={{ width: '100%', height: '37px' }}
                                        placeholder="כל המטפלים"
                                        value={nameTemplate}
                                        onChange={(e: any) => templateChange(e)}
                                        options={templates.map((template: any, i: number) => {
                                            return {
                                                value: template.text,
                                                label: template.name
                                            }
                                        })}
                                        className='brd-rds'
                                    />
                                    <div className='error-message'>
                                    </div>
                                </div>
                            </div>
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        שייך ל
                                    </div>
                                    <div className="value">
                                        <TreeSelect
                                            treeLine
                                            placeholder='שייך ל'
                                            showSearch
                                            style={{
                                                width: '100%',
                                            }}
                                            dropdownStyle={{
                                                maxHeight: 400,
                                                overflow: 'auto',
                                            }}
                                            allowClear
                                            onChange={(v: any) => onChangeRelations(v)}
                                            treeData={treeTreatmentData}
                                            value={chooseRelation}
                                            disabled={disabledEditMode}
                                        />

                                    </div>

                                </div>
                            </div>

                        </div>
                        {/* בחירת תבנית */}
                        <div className="parameter-row single-item">

                        </div>
                        <div className="parameter-row single-item">
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        שלח דוא"ל בשינוי משימה
                                    </div>
                                    <div className="value">
                                        <input type='text' />
                                    </div>
                                    <div className='error-message'>
                                        {/* *{this.state.errors.requiredField} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="parameter-row single-item">
                            <div className={`parameter-item`}>
                                <div className="field">
                                    <div className="title">
                                        צירוף קובץ
                                    </div>
                                    <div className="value">
                                        <input type='file' accept="image/png, image/gif, image/jpeg, application/pdf" onChange={onFileUpload} />
                                        {/* <input type="file" accept="image/png, image/gif, image/jpeg, application/pdf" ref={this.hiddenFileInput} onChange={this.setCarLicenseFile} /> */}
                                    </div>
                                    <div className='error-message'>
                                        {/* *{this.state.errors.requiredField} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            {/* fileAttachments */}
                            {currentData && currentData.fileAttachments && currentData.fileAttachments.map((item: any, index: number) => {
                                return (
                                    <div className='item-data-row flex-space-between' style={{ 'padding': '2px 4px 2px 12px' }} key={index}>
                                        <div className='cell' style={{ 'direction': 'ltr' }}>
                                            {item.FileName}
                                        </div>
                                        <div><FontAwesomeIcon className='pointer' icon={faTrash} onClick={() => onDeleteAttachment(index)} /></div>
                                    </div>
                                )
                            })
                            }
                            {currentData && currentData.treatmentDocuments && currentData.treatmentDocuments.map((item: any, index: number) => {
                                const fileUrlData = item.filePath.split("/");
                                const fileName = fileUrlData[fileUrlData.length - 1]
                                return (
                                    <div className={`item-data-row flex-space-between ${item.isDeleted ? 'hide' : ''}`} style={{ 'padding': '2px 4px 2px 12px' }} key={index}>
                                        <div className='cell' style={{ 'direction': 'ltr' }}>
                                            {fileName}
                                        </div>
                                        <div><FontAwesomeIcon className='pointer' icon={faTrash} onClick={() => onDeleteDocument(index)} /></div>
                                    </div>
                                )
                            })
                            }
                        </div>
                        <div className='parameter-row single-item'>
                            <div className={`parameter-item`}>
                                {/* <div>
                                <Editor
                                    onInit={(evt, editor) => editorRef.current = editor}
                                    apiKey='ks3fr9n4j0mjkuuzhr22kk51hr6yrehhnslwwv5e3vio1yws'
                                    initialValue={currentData.emailBody}
                                    init={{
                                        height: 150,
                                        width: 850,
                                        menubar: false,
                                        plugins: [
                                            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                            'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                        ],
                                        language: "he_IL",
                                        toolbar: 'undo redo | blocks | ' +
                                            'bold italic forecolor | alignleft aligncenter ' +
                                            'alignright alignjustify | bullist numlist outdent indent | ' +
                                            'removeformat | help',
                                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                        convert_nbsp_to_space: true,
                                    }}
                                    onChange={onEmailBodyChange}

                                />
                            </div> */}
                                {
                                    <DraftEditor
                                        initialHtml={currentData.emailBody}
                                        onHtmlChange={(html: string) => onEmailBodyChange(html)}
                                    />
                                }
                            </div>
                        </div>
                        <div className='parameter-row single-item' style={{ marginTop: '10px' }}>
                            <div className='tab-content-title'>
                                פרטים נוספים
                            </div>
                            {/* <button type="button" className="button blue has-icon flex-centered flex-justify-center" onClick={()=>setShowNewAction(true)}>
                                    <div className="icon add"></div>
                                    הוסף פעולה
                                </button> */}
                        </div>
                        <div className='content-table'>
                            <div className='content-header content-table-header client-tasks-list-header'>
                                <div className='cell item-start-date'>
                                    תאריך
                                </div>
                                <div className='cell item-start-date'>
                                    נוצר ע"י
                                </div>
                                <div className='cell item-owner'>
                                    נושא
                                </div>
                                <div className='cell item-details'>
                                    תיאור פעולה
                                </div>
                                <div className='cell item-actions'>
                                </div>
                            </div>
                            <div className='content-table-body'>
                                {showNewAction && newAction && <div className='item-data-row'>
                                    <div className='cell item-start-date'>
                                        <CompDatePicker value={newAction.date} onChange={(date: Date) => onNewActionParameterChange('date', date)} />
                                    </div>
                                    <div className='cell item-owner'>
                                        <input type='text' disabled onChange={(e: any) => onNewActionParameterChange2('owner', e)} />
                                    </div>
                                    <div className='cell item-label'>
                                        <input type='text' onChange={(e: any) => onNewActionParameterChange2('label', e)} />
                                    </div>
                                    <div className='cell item-details'>
                                        <input type='text' onChange={(e: any) => onNewActionParameterChange2('description', e)} />
                                    </div>
                                    <div className='cell item-actions pointer'>
                                        <FontAwesomeIcon icon={faXmark} onClick={onClearNewAction} />
                                        <FontAwesomeIcon icon={faPlus} onClick={onSaveNewAction} />
                                    </div>
                                </div>}
                                {aditionalActionList.map((item: any, index: number) => {
                                    return (
                                        <div className='item-data-row' key={index}>
                                            <div className='cell item-start-date'>
                                                {item.date}
                                            </div>
                                            <div className='cell item-owner'>
                                                {item.owner}
                                            </div>
                                            <div className='cell item-label'>
                                                {item.label}
                                            </div>
                                            <div className='cell item-details'>
                                                {item.description}
                                            </div>
                                            <div className='cell item-actions pointer'>
                                                {/* <FontAwesomeIcon icon={faPen} /> */}
                                                {/* <FontAwesomeIcon icon={faTrash} onClick={()=>onDeleteAction(index)} /> */}
                                            </div>
                                        </div>
                                    )
                                })}
                                {currentData && currentData.treatmentActivities && currentData.treatmentActivities.map((item: any, index: number) => {
                                    const user = usersList.find((a: any) => a.value == item.createdById);
                                    const raw = item && item.note ? item.note : '';
                                    const html = raw.replace(/\n/g, '<br/>');
                                    return (
                                        <div className='item-data-row' key={index}>
                                            <div className='cell item-start-date'>
                                                {moment(item.createdDate).format('YYYY-MM-DD HH:mm')}
                                            </div>
                                            <div className='cell item-owner'>
                                                {user && user.label}
                                            </div>
                                            <div className='cell item-label'>
                                                {item.topic}
                                            </div>
                                            <Tooltip
                                                title={<span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />}
                                                overlayInnerStyle={{ maxWidth: 480 }}
                                            >
                                                <div
                                                    className="cell item-details"
                                                    style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                >
                                                    {item.note.replace(/(<([^>]+)>)/gi, '')}
                                                </div>
                                            </Tooltip>
                                            <div className='cell item-actions pointer'>
                                                {/* <FontAwesomeIcon icon={faPen} /> */}
                                                {/* <FontAwesomeIcon className='pointer' icon={faTrash} onClick={()=>onDeleteActivity(index)} /> */}
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                        </div>
                    </div>
                    <div className="popup-footer">
                        <button className="button blue pointer" onClick={(e: any) => onSaveAssignment()}>
                            שמור
                        </button>
                        <button className={`button white blue-border pointer ${showPrintBtn ? '' : 'hide'}`} disabled onClick={(e: any) => emptyFunc()}>
                            הדפס
                        </button>
                        <button className="button white blue-border pointer" onClick={(e: any) => closePopup()}>
                            ביטול
                        </button>
                    </div>
                </div>
            </section>
        </div>
    </>

    );
    // }
}
export default TasksAddTaskPopup;